import CustomInput from "@/components/CustomInput/CustomInput.vue";
import UploadImage from "@/components/UploadImage/UploadImage.vue";
import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue";
import UrlBlock from "@/components/UrlBlock/UrlBlock.vue";

import {Hooper, Slide, Pagination as HooperPagination} from 'hooper';
import helper from "../../store/helpers/helper.js";

import {mapGetters} from "vuex"

export default {
  name: 'PostCover',
  props: ['page', 'img', 'old', 'view', 'rewardType'],
  data() {
    return {
      slides_quantity: 0,
      image: "",
      facebookUrl: "https://www.facebook.com/testapiyo/",
      instagram: '',
      email: '',
      buttons: [
        {id: 1, name: `Get ${this.$props.rewardType}`},
        {id: 2, name: 'Get reward'},

      ],
      steps: this.$props.page.steps,
    }
  },
  components: {
    CustomInput,
    UploadImage,
    CustomDropdownBorder,
    // Carousel,
    // Slide,
    UrlBlock,
    Hooper,
    Slide,
    HooperPagination
  },
  methods: {
    formatTextDescription() {
      let description = helper.formatTextForOutput(this.page.description);
      return description;
    },
    isSkippableStep(step) {
      for (let key in step) {
        if (step[key].check.skippable) {
          return true;
        }
      }
      return false;
    },
    skipTextFormat(step) {
      let skippableValues = [];
      for (let key in step) {
        skippableValues.push(step[key].check.skippable);
      }
      skippableValues = skippableValues.map(item => {
        return (item !== false) ? item : 0;
      });
      let maxS = '';
      if (skippableValues.length > 0) {
        let max = Math.max(...skippableValues);
        maxS =  (max > 1) ? ' in ' + Math.max(...skippableValues) + 's' : '';
      }
      return 'Skip' + maxS;
    },
    isLastGate(step, item) {
      return (step.length - 1) === step.indexOf(item);
    },
    isNotLastGate(step, item) {
      return (step.length - 1) > step.indexOf(item);
    },
    async checkSteps() {
      // let forCheckSteps = []
      // this.$props.page.steps.forEach(step => {
      //     if (step.check.inputs.length > 0) {
      //         forCheckSteps.push(step)
      //         const data = {
      //             checkingPage: step.check.check1.link,
      //             userForCheck: this.instagram
      //         }
      //     }
      // })

    },
    toPage(src) {
      // window.open(src, "action", 'width=800,height=600');
      return false;
    },
    formate(steps) {
      let arrayOfSteps = []
      let slides = []
      for (let i = 0; i < steps.length; i++) {
        let step = steps[i]
        if (step.status) {
          // console.log(`${step.icon}`, step);
          if (step.check.type === 'Or' && ((step.check.inputs?.length > 0 && step.icon !== 'messenger') || (step.check.fillable === false))) {
            arrayOfSteps.push(steps[i], steps[i + 1])
            arrayOfSteps = Array.from(new Set(arrayOfSteps.map(JSON.stringify))).map(JSON.parse);
          }
          if (step.check.type === 'And' && ((step.check.inputs?.length > 0 && step.icon !== 'messenger') || (step.check.fillable === false))) {
            if (arrayOfSteps.length > 0) {
              slides.push(arrayOfSteps)
              arrayOfSteps = []
            } else {
              slides.push([step])
            }
          }
        }
      }
      if (slides.length > 0 ) {
        this.restart();
      }
      this.slides_quantity = slides
      return slides
    },
    getData(payload) {
    },
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.carousel = payload.currentSlide;
    },
    restart () {
      return this.$nextTick().then(() => {
        this.$refs.carousel.update();
        if (this.slides_quantity.length < this.carousel + 1) {
          this.$refs.carousel.slideTo(this.carousel - 1);
        }
      });
    },
    createPlaceholder(name) {
      switch (name) {
        case 'E-mail capture':
          return 'Enter your email';
        case 'SMS':
          return 'Enter your phone (start with +)';
        case 'Telegram':
          return `Enter code from ${name} App`;
        case 'Telegram_channel':
          return `Enter your telegram profile link`;
        default:
          return `Enter your ${name} profile link`;
      }
    },
    createSkipText(skipSecond) {
      if (skipSecond > 1) {
        return `Skip in ${skipSecond}s`;
      } else {
        return 'Skip';
      }
    }
  },
  mounted() {
    // if (localStorage.image) {
    //     this.page.cover = localStorage.image;
    //     if (this.$props.img != undefined) {
    //         this.page.cover = this.$props.img;
    //     }
    // }
    if (this.$props.img) {
      this.image = this.$props.img
      this.page.cover = this.$props.img;
    }
  },
  computed: {
    ...mapGetters(['getWidth']),
    width() {
      return this.getWidth
    },
    getButtonFormatted() {
      if (this.$props.page.button == 2) return 'Get reward'
      switch (this.$props.rewardType) {
        case 'link':
          return 'Get link'
        case 'coupon_code':
          return 'Get coupon code'
        case 'image':
          return 'Get image'
        default:
          return 'Get reward'
      }
    },
    isActive() {
      // todo есть метод replace у croppper, попробовать не рендерить несколько вариантов а перестраивать
      if (this.view === 'mobile' && this.width < 420) return '200'
      if (this.view === 'mobile') return '350'

      if (this.view === 'laptop' && this.width > 1740) return '450'
      if (this.width <= 1740 && this.width > 1560) return '350'
      if (this.width <= 1560 && this.width > 1400) return '200'
      if (this.width <= 1400 && this.width > 726) return '350'
      if (this.width <= 726) return '200'
    }
  },
  watch: {
    image(newImage) {
      localStorage.image = newImage;
    },
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
    'page.reward_type': function (val) {
      console.log(val)
    }
  }
}
